import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import Model from "@ckeditor/ckeditor5-ui/src/model";
import Collection from "@ckeditor/ckeditor5-utils/src/collection";
import FileDialogButtonView from '@ckeditor/ckeditor5-upload/src/ui/filedialogbuttonview';
import {
    addListToDropdown,
    createDropdown
} from "@ckeditor/ckeditor5-ui/src/dropdown/utils";
import SplitButtonView from "@ckeditor/ckeditor5-ui/src/dropdown/button/splitbuttonview";
import Icon from '../icons/icon-photo-general-group.svg';
import TwoIcon from '../icons/icon-photo-general-2.svg';
import ThreeIcon from '../icons/icon-photo-general-3.svg';
import FourIcon from '../icons/icon-photo-general-4.svg';
import FiveIcon from '../icons/icon-photo-general-5.svg';
import SixIcon from '../icons/icon-photo-general-6.svg';

export default class DropDownPhotoGeneral extends Plugin {
    init() {
        const editor = this.editor;
        editor.ui.componentFactory.add("DropDownPhotoGeneral", locale => {
            const dropdownView = createDropdown(locale, SplitButtonView);
            dropdownView.buttonView.actionView.set({
                withText: false,
                label: "Изображения с общей подписью",
                icon: Icon,
                tooltip: true
            });
            dropdownView.class = 'comp_g';
            const items = new Collection();
            items.add({
                type: "button",
                model: new Model({
                    id: 'Two',
                    withText: false,
                    icon: TwoIcon,
                    label: "2 фото",
                    tooltip: true
                })
            });
            items.add({
                type: "button",
                model: new Model({
                    id: 'Three',
                    withText: false,
                    icon: ThreeIcon,
                    label: "3 фото",
                    tooltip: true
                })
            });
            items.add({
                type: "button",
                model: new Model({
                    id: 'Four',
                    withText: false,
                    icon: FourIcon,
                    label: "4 фото",
                    tooltip: true
                })
            });
            items.add({
                type: "button",
                model: new Model({
                    id: 'Five',
                    withText: false,
                    icon: FiveIcon,
                    label: "5 фото",
                    tooltip: true
                })
            });
            items.add({
                type: "button",
                model: new Model({
                    id: 'Six',
                    withText: false,
                    icon: SixIcon,
                    label: "6 фото",
                    tooltip: true
                })
            });
            addListToDropdown(dropdownView, items);
            dropdownView.on('execute', (eventInfo) => {
                const {id, label} = eventInfo.source;
                editor.execute('insert' + id + 'PhotoGeneral');
            });

            return dropdownView;
        });
    }
}